import { useFeed } from "../hooks/useFeed";
import { PanelHeader } from "./PanelHeader";
import type { VenueOccupancy } from "@kmitl/shared";

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "";

const TYPE_ICON: Record<VenueOccupancy["type"], string> = {
  canteen:  "◉",
  lab:      "⬡",
  library:  "▣",
  dorm:     "▦",
  gym:      "◈",
  clinic:   "✚",
};

function fillColor(pct: number, type: VenueOccupancy["type"]): string {
  if (type === "dorm") {
    if (pct >= 90) return "var(--bad)";
    if (pct >= 75) return "var(--warn)";
    return "var(--good)";
  }
  if (pct >= 95) return "var(--bad)";
  if (pct >= 75) return "var(--warn)";
  return "var(--data)";
}

function statusLabel(v: VenueOccupancy): string {
  if (v.status === "closed") return "CLOSED";
  if (v.status === "maintenance") return "MAINT";
  if (v.pct >= 95) return "FULL";
  if (v.pct >= 80) return "BUSY";
  if (v.pct < 20) return "QUIET";
  return "";
}

export function CampusOccupancyPanel() {
  const feed = useFeed<VenueOccupancy>(`${API_BASE}/api/campus/occupancy`, 5 * 60_000);
  const venues = feed.data;

  return (
    <div className="occupancy-panel left-section">
      <PanelHeader
        title="VENUE OCCUPANCY"
        ageMinutes={feed.ageMinutes}
        fallbackTier={feed.fallbackTier === "loading" ? undefined : feed.fallbackTier}
        source="kmitl-bems"
      />
      <div className="occupancy-list">
        {venues.length === 0 && (
          <p className="occ-empty mono">Loading…</p>
        )}
        {venues.map((v) => {
          const bar = Math.round(v.pct);
          const color = fillColor(v.pct, v.type);
          const badge = statusLabel(v);
          return (
            <div key={v.id} className="occ-row" title={`${v.name.en} — ${v.current}/${v.capacity} (${v.pct}%)`}>
              <span className="occ-icon" style={{ color }}>
                {TYPE_ICON[v.type]}
              </span>
              <span className="occ-name mono">{v.name.en}</span>
              <div className="occ-bar-track">
                <div
                  className="occ-bar-fill"
                  style={{ width: `${bar}%`, background: color }}
                />
              </div>
              <span className="occ-pct mono" style={{ color }}>{bar}%</span>
              {badge && (
                <span className="occ-badge mono" style={{ color }}>{badge}</span>
              )}
              {v.waitMinutes != null && v.waitMinutes > 0 && (
                <span className="occ-wait mono" title={`Estimated wait: ${v.waitMinutes} min`}>
                  {v.waitMinutes}m
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
